import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useAlert } from "react-alert";
import api from "../../seller-apis/api";
import servicesApi from "../../seller-apis/servicesApi";
import convertCsvFileToJsonArray from "../../utilities/convertFileToJsonArray";
import { variables } from "../../Variables.json";
import { meOnly } from '../../seller-apis/apidataField'
import axios from "axios";
import "./agreement.css";
import { GenUtilities } from "../../utilities/GenUtilities";

function AgreementDocument(props) {
  const [uploadStart, setUploadStart] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadProdCount, setUploadProdCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const [catNavToggleState, setCatNavToggleState] = useState("");
  const [subCatNavToggleState, setsubCatNavToggleState] = useState("");
  const [toggleCategory, setToggleCategory] = useState(false);
  const [categorySelected, setCategorySelected] = useState(false);
  const [selectedUploadCategory, setSelectedUploadCategory] = useState(null);
  const [finalCategoryArray, setFinalCategoryArray] = useState(null);
  const [vendorId, setVendorId] = useState("");
  const [profileInfo, setProfileInfo] = useState({});
  const [agreementSampleDownloaded, setAgreementSampleDownloaded] = useState(false);
  const [show, setShow] = useState(false);
  const [resubmit, setResubmit] = useState(false);
  const alert = useAlert();
  useEffect(async () => {
    const ress = await servicesApi.categories.categoryTree({});
    let catList = ress.data.subCategories;
    getProfileInfo();
    setCategories(catList);
  }, []);
  async function uploadData(e) {
    setUploadStart(true);
    const array = await convertCsvFileToJsonArray(e.target.files);
    // console.log("array: ", array);

    // return;
    let productData =[];
    for (let i = 0; i < array.length; i++) {
      if (!array[i]["Product Name"]) {
        alert.info("Please enter a valid Product name");
        setCategorySelected(false);
        setUploadStart(false);
        setUploadError(false);
        setUploadSuccess(false);
        return false;
      }

      const imgUrls = [];
      let keywords =[];
      // console.log(array);
      if(array[i]["Meta Keywords"]){
       keywords = array[i]["Meta Keywords"].split(",");
      }
      let brandid=0;
  if(array[i]['Brand'])
    {
      let brandData = await api.brand.getManufacturers( {"filter": { "name-id": array[i]['Brand']} } );
          brandData = brandData.data;
          console.log("branddata",brandData)
      brandid = brandData.length > 0 ? brandData[0].manufacturerId: 0;
    }
      const piData = {
        // images: imgUrls,
        description: array[i]["Description"],
        price: array[i]["Transfer Price"],
        taxClass: array[i]["GST%"],
        productName: array[i]["Product Name"],
        videos: [array[i]["Video Link"]],
        manufacturer: brandid,
        categories: finalCategoryArray,
        metaInformation: {
          keywords: keywords,
        },
        status: "draft",
        HSN: array[i]["Hsn"]
      }

      productData.push(piData);
    }
    console.log(productData);
    setUploadProdCount(productData.length);

    api.product
      .addNewProductBulk(productData)
      .then((res) => {
        setUploadStart(false);
        setUploadError(false);
        setUploadSuccess(true);
        //   alert.success("Products added successfully");
        window.location.assign("/my-inventory/new_product_request/drafted");
      })
      .catch((err) => {
        console.log(err);
        setUploadStart(false);
        setUploadError(true);
        setUploadSuccess(false);
      });
  }
  const handleDownload = () => {
    // get PDF file
    const fileUrl = "./AgreementDoc.pdf"; // Replace with your local file URL
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "AgreementDoc.pdf"; // Specify the desired filename
    link.click();

    // fetch("AgreementDoc.pdf").then((response) => {
    //     response.blob().then((blob) => {
    //         const fileURL =
    //             window.URL.createObjectURL(blob);
                
    //         // Setting various property values
    //         let alink = document.createElement("a");
    //         alink.href = fileURL;
    //         alink.download = "AgreementDoc.pdf";
    //         alink.click();
    //     });
    // });

    // update into db
    const updateData = {
      _id: vendorId,
      agreementSampleDownloaded: true
    }
    api.seller
      .updateInfo(updateData)
      .then((res) => {
        if( res.message == 'vendor updated' )
        {
          setAgreementSampleDownloaded(true);
        }
      })
      .catch((err) => console.log(err));
  };
  const toggleCategoryFunc = () => {
    setToggleCategory(!toggleCategory);
    setCatNavToggleState("");
    setsubCatNavToggleState("");
  }
  const selectCategoryFunction = (name,targetId) => {
    setCategorySelected(true);
    setToggleCategory(!toggleCategory);
    setSelectedUploadCategory(name);
    let cats=getAllParents(categories, targetId);
    setFinalCategoryArray(cats);
  };

  const getAllParents = (categories, targetId, parentIds = []) => {
    for (const category of categories) {
      if (category._id === targetId) {
        return [...parentIds, category._id];
      }
      if (category.subCategories) {
        const found = getAllParents(category.subCategories, targetId, [
          ...parentIds,
          category._id,
        ]);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const setSelectedUploadCategoryfunc=(categoryname,targetId)=>{
    setSelectedUploadCategory(categoryname);
    let cats=getAllParents(categories, targetId);
    setFinalCategoryArray(cats);
  }

  // Upload signed doc
  function uploadSignedDoc(event) {
    let comImg;
    let imageFinal;
    let registerImage;
    let filesSize = event.target.files[0].size;
    // if (filesSize <= variables.limit.RegisterVendor.panSize) {
      // for (let i = 0; i < 1; i++) {
        // console.log(i);
        var str = event.target.files[0].name;
        // setSeletedPanFileName(str);
        // let extension = event.target.files[0].name.slice(
        //   event.target.files[0].name.lastIndexOf(".")
        // );
        comImg = str.replace(0, str.lastIndexOf("."));
        imageFinal = GenUtilities.removeSpacesFromName("v2_agreementDoc_" + vendorId + "_" + comImg);
        registerImage = event.target.files[0];
        // fileName=imageFinal;
        console.log(imageFinal);
        var data = {
          imageName: imageFinal,
          type: "products",
          bucket: "seller_doc"
        };
        servicesApi
          .saveImage(data)
          .then((res) => {
            axios({
              method: "put",
              url: res.data,
              data: registerImage,
              onUploadProgress: (data) => {
                //Set the progress value to show the progress bar
                // setpanUploadProg(Math.round((100 * data.loaded) / data.total));
              },
            })
              .then((response) => {
                // setpanUploadProg();
                console.log("Doc response: ", response);

                let isStep4 = false;
                if (profileInfo?.profileStepsCompleted?.length > 0) {
                  for(let i = 0; i < profileInfo.profileStepsCompleted.length; i++) {
                    if (profileInfo.profileStepsCompleted[i].name =='step4' ) {
                      isStep4 = true;
                      break;
                    }
                  }
                }

                let updateData = {
                  _id: vendorId,
                  agreementFile: imageFinal,
                  agreementVerified: {
                    status: "PENDING"
                  }
                }
                if (!isStep4) {
                  updateData.profileStepsCompleted = [
                                ...profileInfo.profileStepsCompleted,
                                {
                                    name: 'step4',
                                    value: true,
                                }
                            ]
                }
                api.seller
                  .updateInfo(updateData)
                  .then((res) => {
                    if(res.message == 'vendor updated')
                    {
                      alert.info("Doc uploaded successfully");
                      getProfileInfo();
                    }
                  })
                  .catch((err) => console.log(err));

              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => console.log(err));
    // else {
    //   // document.getElementById("panInput").value = "";
    //   alert.info("File size can be upto 2 Mb max.");
    // }
  }

  function showDoc() {
    let ele = document.getElementById("viewDoc");
    const url = "mob/products/"+ profileInfo?.agreementFile;
    let data = {
      "bucket":"seller_doc",
      "key":url
    }
    api.docs.getImage(data).then((response) => {
        if (response?.data) {
          const link = document.createElement('a');
          link.href = response?.data;
          link.setAttribute('download', profileInfo?.agreementFile);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link)
        }
      }).catch((err) => ele.innerHTML = "<p>Not found</p>")

  }

  const getProfileInfo=()=>{
      api.auth
        .me(meOnly({"excludeField": {
              active: 1, 
              profileStepsCompleted: 1, 
              agreementFile: 1, 
              agreementVerified: 1, 
              agreementSampleDownloaded: 1
            }
          }
        ))
        .then((res) => {
          setProfileInfo(res.data);
          setVendorId(res.data._id);
          setAgreementSampleDownloaded(res.data.agreementSampleDownloaded);
          // if (res.message === "seller fetched") {
          //   setisVerifiedSeller(true);
          // }
        })
        .catch((err) => console.log(err));
  }

  return (
    <>
      <div className="bulkuploadprod">
        <div className="upload-doc">
          {/* <div className="text"></div> */}
          <div className="relative">
            { agreementSampleDownloaded && (
              <>
              { !profileInfo.agreementVerified || (profileInfo?.agreementVerified && profileInfo?.agreementVerified.status == "REJECTED" && resubmit) ? (
              <div
                className="button upload-file  file-upload"
                htmlFor="file-upload-input"
              >
                <img src="/upload.webp" alt="upload" />
                Upload Signed Document
                <input
                  id="file-upload-input"
                  onChange={(event) => uploadSignedDoc(event)}
                  type="file"
                />
              </div>
              ) : 
              <>
                <div>
                  <span className="f-500">Document status: </span>
                  { profileInfo?.agreementVerified && (
                    <>
                      { profileInfo?.agreementVerified.status == "PENDING" && (
                        <span className="text-danger f-500">Pending for approval</span>
                      )}
                      { profileInfo?.agreementVerified.status == "APPROVED" && (
                        <span className="text-success f-500">Approved</span>
                      )}
                      { profileInfo?.agreementVerified.status == "REJECTED" && (
                        <span className="text-danger f-500">Rejected</span>
                      )}
                    </>
                  )}
                </div>
              </> }
              </>
            )}
            {/* <div className="button button-disabled">
                <img src="/disabled-upload.webp" alt="upload" />
                Upload Signed Doc
            </div> */}
            {/* <div className="file-Processing">
                <div className="custom-loader"></div>
                <div className="precessing">Uploading...</div>
                <div className="file-name">Product.xlsx</div>
            </div> */}
            {uploadSuccess && (
              <div className="upload-success">
                {uploadProdCount} Document Uploaded Successfully
              </div>
            )}
            {uploadError && (
              <div className="upload-failed">Processing Failed</div>
            )}
          </div>
          { (!profileInfo?.agreementVerified || (profileInfo?.agreementVerified && profileInfo?.agreementVerified.status == "REJECTED")) ? (
            <div>
              {profileInfo?.agreementVerified?.status == "REJECTED" && !resubmit ? (
                <button class="px-1 order_table_btn_details resubBtn" onClick={() => setResubmit(true)}>Resubmit</button>
              ) :
                <label className="button" onClick={handleDownload}>
                  <img src="/download.webp" alt="upload" />
                  Download Agreement Document
                </label>
              }
            </div>
          ):
            <div className="d-flex align-items-center">
              <div className="view-icon" onClick={() => showDoc()}>
                <img src="/view-icon.webp" alt="icon" />
              </div>
              <div
                id="viewDoc"
                className="view-doc cursor-pointer"
                onClick={() => showDoc()}
              >
                View Document
              </div>
            </div>
          }

        </div>
        <div className="instructions-grid">
          {/* <div className="video-box">
            <div className="text">How to use bulk upload?</div>
            <div className="inst-video">
              <iframe src="https://player.vimeo.com/video/849059662?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen" style={{width:"400px", height:"240px"}} title="Bulk upload"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
              
            </div>
          </div> */}
          {(!profileInfo.agreementFile || (profileInfo?.agreementVerified?.status == "REJECTED" && resubmit))  &&
            <div className="instruction">
              <div className="heading">Instruction:</div>
              <div className="inst-text">
                <p>
                  <span>Step 1:</span> Download the sample file from the “Download Agreement Document” Option.
                </p>
                <p>
                  <span>Step 2:</span> Fill the details & Sign the document.
                </p>
                <p>
                  <span>Step 3:</span> Scan the document.
                </p>
                <p>
                  <span>Step 4:</span> Upload the document by clicking on "Upload Signed Document".
                </p>
              </div>
            </div>
          }

        </div>
      </div>

      {/* <Modal
        className="custom-modal"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Body>
          <div>
            <iframe src={"https://toolsvilla-prod.s3.ap-south-1.amazonaws.com/"+ profileInfo?.agreementFile} style="width:600px; height:500px;"></iframe>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
}

export default AgreementDocument;
